import { rsapub } from "@/services/rsapub";

export const useAPIRsapub = () => {
  const handleAPIRsapub = async () => {
    const data = await rsapub();
    return data;
  };

  return {
    handleAPIRsapub,
  };
};
